<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addMemberDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item prop="telephoneNumber" label="会员手机号:">
          <el-input type="text" v-model="form.telephoneNumber"></el-input>
        </el-form-item>

        <el-form-item prop="name" label="会员姓名:">
          <el-input type="text" v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item prop="accountType" label="账号类型:">
          <el-select v-model="form.accountType" placeholder="账号类型">
            <el-option
              v-for="item in accountType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item prop="memberType" label="会员类型:">
          <el-select v-model="form.memberType" placeholder="会员类型">
            <el-option
              v-for="item in memberType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="memberStatus" label="会员状态:">
          <el-select v-model="form.memberStatus" placeholder="会员状态">
            <el-option
              v-for="item in memberStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="memberNote" label="会员备注">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入会员备注"
            v-model="form.memberNote"
          ></el-input>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { addMember, updateMember } from "@/api/member";
import { getToken } from "@/utils/auth";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  name: "addFundDialogs",
  data() {
    let validateData = (rule, value, callback) => {
      if (value === "") {
        let text;
        if (rule.field == "telephoneNumber") {
          text = "手机号";
        } else if (rule.field == "name") {
          text = "姓名";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        let numReg = /^1[3456789]\d{9}$/;
        if (!numReg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }
    };
    return {
      isVisible: this.isShow,
      form: {
        userName: "",
        telephoneNumber: "",
        name: "",
        memberType: "",
        accountType: "",
        memberStatus: "",
        classhourddl: "",
        memberNote: "",
        classhourspendddl: "",
        classhourspends: "",
      },
      memberType: [
        { label: "临时会员", value: "0" },
        { label: "正式会员", value: "1" },
      ],
      accountType: [
        { label: "学员", value: "0" },
        { label: "管理员", value: "1" },
      ],
      memberStatus: [
        { label: "待审核", value: "0" },
        { label: "审核通过", value: "1" },
      ],
      form_rules: {
        telephoneNumber: [
          { required: true, validator: validateData, trigger: "blur" },
        ],
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        memberType: [
          { required: true, message: "请选择会员类型", trigger: "blur" },
        ],
        accountType: [
          { required: true, message: "请选择账号类型", trigger: "blur" },
        ],
        memberStatus: [
          { required: true, message: "请选择会员状态", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
  },
  computed: {
    ...mapGetters(["addMemberDialog"]),
  },
  created() {},
  mounted() {
    if (this.addMemberDialog.type === "edit") {
      this.form = this.dialogRow;
      this.form.memberType = this.dialogRow.memberType.toString();
      this.form.memberStatus = this.dialogRow.memberStatus.toString();
      console.log(this.form);
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          if (this.addMemberDialog.type === "edit") {
            updateMember(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "修改(" + this.form.name + ")会员操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.isVisible = false;
                this.$emit("getMemberList");
              }
            });
          } else {
            // add
            addMember(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "新增(" + this.form.name + ")会员操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getMemberList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
